export default __webpack_public_path__ + "static/media/process-com-illustration.111b4f5a.png";